module.exports = __webpack_public_path__ + "img/hair_back_female_straight_long.fd0f9d71.png";